/* eslint-disable no-restricted-globals */
import _ from 'lodash'

import { env } from 'admin/lib/config/env-config.js'

/**
 * @type {import("@azure/msal-browser").Configuration}
 */
export const config = {
  auth: {
    authority: env.NX_B2C_AUTHORITY + '/' + env.NX_B2C_SIGNIN_POLICY,
    knownAuthorities: [env.NX_B2C_AUTHORITY],
    clientId: env.NX_CLIENT_ID,
    redirectUri: location.origin + '/signin-oidc',
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: location.origin + '/'
  },
  cache: {
    cacheLocation: 'sessionStorage',
    claimsBasedCachingEnabled: true
  },
  system: {
    allowRedirectInIframe: true,
    iframeHashTimeout: 8000

    // loggerOptions: {
    //   logLevel: 1,
    //   piiLoggingEnabled: true,
    //   loggerCallback: (level, message) => {
    //     console.log(message)
    //   }
    // }
  }
}

export const passwordResetAuthority =
  env.NX_B2C_AUTHORITY + '/' + env.NX_B2C_RESET_PASSWORD_POLICY

export const authenticationParameters = {
  scopes: _.uniq(['openid', ...env.NX_SCOPES.split(' ')])
}

export const apiURL = env.NX_API_URL

export const correlationHeader = 'zametek-utility-trackingcontext'
